import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalendarEventService {
  private monthSelectedSubject = new Subject<Date>();
  private yearSelectedSubject = new Subject<Date>();

  monthSelected$ = this.monthSelectedSubject.asObservable();
  yearSelected$ = this.yearSelectedSubject.asObservable();

  emitMonthSelected(date: Date) {
    this.monthSelectedSubject.next(date);
  }

  emitYearSelected(date: Date) {
    this.yearSelectedSubject.next(date);
  }
}
